/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './navbar.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './client/navbar-client.component.ngfactory';
import * as i3 from '../../../../../../src/app/components/shared/navbar/client/store/navbar-statistics-state.service';
import * as i4 from '../../../../../../src/app/components/client/shared/services/shared-interview.service';
import * as i5 from '../../../../../../src/app/providers/auth-http.service';
import * as i6 from '../../../../../../src/app/components/shared/navbar/client/navbar-client.component';
import * as i7 from 'angular2-modal/plugins/bootstrap';
import * as i8 from '../../../../../../src/app/components/client/shared/services/shared-client.service';
import * as i9 from '../../../../../../src/app/providers/file.service';
import * as i10 from '../../../../../../src/app/providers/auth.service';
import * as i11 from '../../../../../../src/app/providers/posthog.service';
import * as i12 from './guest/navbar-guest.component.ngfactory';
import * as i13 from '../../../../../../src/app/components/shared/navbar/guest/navbar-guest.component';
import * as i14 from '@angular/common';
import * as i15 from '../notification/bar/client/bar.component.ngfactory';
import * as i16 from '../../../../../../src/app/components/shared/notification/bar/client/bar.component';
import * as i17 from '../../../../../../src/app/providers/cookie.service';
import * as i18 from '../../../../../../src/app/components/shared/notification/notification.service';
import * as i19 from '../../../../../../src/app/components/shared/navbar/navbar.component';
const styles_NavbarComponent:any[] = [i0.styles];
export const RenderType_NavbarComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NavbarComponent,data:{}});
function View_NavbarComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'navbar-client',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarClientComponent_0,
      i2.RenderType_NavbarClientComponent)),i1.ɵprd(512,(null as any),i3.NavbarStatisticsStateService,
      i3.NavbarStatisticsStateService,([] as any[])),i1.ɵprd(512,(null as any),i4.SharedInterviewService,
      i4.SharedInterviewService,[i5.AuthHttpClient]),i1.ɵdid(245760,(null as any),
      0,i6.NavbarClientComponent,[i7.Modal,i8.SharedClientService,i9.FileHelper,i10.AuthService,
          i11.PosthogService,i3.NavbarStatisticsStateService,i4.SharedInterviewService],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,3,0);
  },(null as any));
}
function View_NavbarComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'navbar-guest',
      ([] as any[]),(null as any),(null as any),(null as any),i12.View_NavbarGuestComponent_0,
      i12.RenderType_NavbarGuestComponent)),i1.ɵdid(49152,(null as any),0,i13.NavbarGuestComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
function View_NavbarComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'nav',[['class',
      'navbar navbar-default']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i1.ɵdid(16384,(null as any),0,i14.NgSwitch,([] as any[]),{ngSwitch:[0,
      'ngSwitch']},(null as any)),(_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NavbarComponent_2)),
      i1.ɵdid(278528,(null as any),0,i14.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,
          i14.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n	'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_NavbarComponent_3)),i1.ɵdid(278528,(null as any),0,i14.NgSwitchCase,
          [i1.ViewContainerRef,i1.TemplateRef,i14.NgSwitch],{ngSwitchCase:[0,'ngSwitchCase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.navUserType;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = 'client';
    _ck(_v,4,0,currVal_1);
    const currVal_2:any = 'guest';
    _ck(_v,7,0,currVal_2);
  },(null as any));
}
function View_NavbarComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'notification-bar-client',
      ([] as any[]),(null as any),(null as any),(null as any),i15.View_NotificationBarClientComponent_0,
      i15.RenderType_NotificationBarClientComponent)),i1.ɵdid(245760,(null as any),
      0,i16.NotificationBarClientComponent,[i10.AuthService,i17.CookieService,i18.NotificationService,
          i8.SharedClientService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
function View_NavbarComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
      (null as any),0,i14.NgSwitch,([] as any[]),{ngSwitch:[0,'ngSwitch']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NavbarComponent_5)),i1.ɵdid(278528,(null as any),
          0,i14.NgSwitchCase,[i1.ViewContainerRef,i1.TemplateRef,i14.NgSwitch],{ngSwitchCase:[0,
              'ngSwitchCase']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.navUserType;
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = 'client';
        _ck(_v,4,0,currVal_1);
      },(null as any));
}
export function View_NavbarComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NavbarComponent_1)),i1.ɵdid(16384,(null as any),0,i14.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NavbarComponent_4)),i1.ɵdid(16384,(null as any),0,i14.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n\n']))],(_ck,_v) => {
    var _co:i19.NavbarComponent = _v.component;
    const currVal_0:any = _co.navUserType;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.navUserType;
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_NavbarComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'hj-navbar',([] as any[]),
      (null as any),(null as any),(null as any),View_NavbarComponent_0,RenderType_NavbarComponent)),
      i1.ɵdid(245760,(null as any),0,i19.NavbarComponent,[i10.AuthService],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NavbarComponentNgFactory:i1.ComponentFactory<i19.NavbarComponent> = i1.ɵccf('hj-navbar',
    i19.NavbarComponent,View_NavbarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9uYXZiYXIvbmF2YmFyLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9zaGFyZWQvbmF2YmFyL25hdmJhci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9zaGFyZWQvbmF2YmFyL25hdmJhci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3NoYXJlZC9uYXZiYXIvbmF2YmFyLmNvbXBvbmVudC50cy5OYXZiYXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8bmF2IGNsYXNzPVwibmF2YmFyIG5hdmJhci1kZWZhdWx0XCIgKm5nSWY9XCJuYXZVc2VyVHlwZVwiIFtuZ1N3aXRjaF09XCJuYXZVc2VyVHlwZVwiPlxuXHQ8bmF2YmFyLWNsaWVudCAqbmdTd2l0Y2hDYXNlPVwiJ2NsaWVudCdcIj48L25hdmJhci1jbGllbnQ+XG5cdDxuYXZiYXItZ3Vlc3QgKm5nU3dpdGNoQ2FzZT1cIidndWVzdCdcIj48L25hdmJhci1ndWVzdD5cbjwvbmF2PlxuPGRpdiAqbmdJZj1cIm5hdlVzZXJUeXBlXCIgW25nU3dpdGNoXT1cIm5hdlVzZXJUeXBlXCI+XG5cdDxub3RpZmljYXRpb24tYmFyLWNsaWVudCAqbmdTd2l0Y2hDYXNlPVwiJ2NsaWVudCdcIj48L25vdGlmaWNhdGlvbi1iYXItY2xpZW50PlxuPC9kaXY+XG5cbiIsIjxoai1uYXZiYXI+PC9oai1uYXZiYXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQ0M7TUFBQTt5Q0FBQTtzQ0FBQTtnQ0FBQSw0QkFBQTtNQUFBO3NGQUFBO01BQUE7SUFBQTs7OztvQkFDQTtNQUFBO3lDQUFBLFVBQUE7TUFBQTs7O29CQUZEO01BQUE7TUFBQSx1QkFBQTtNQUFBLDRCQUFnRix3Q0FDL0U7YUFBQTthQUFBO3NCQUFBLG1EQUF3RDtVQUFBLFVBQ3hEO1VBQUEsZ0NBQUE7VUFBQTtVQUFBLGVBQXFEOztJQUZDO0lBQXZELFdBQXVELFNBQXZEO0lBQ2dCO0lBQWYsV0FBZSxTQUFmO0lBQ2M7SUFBZCxXQUFjLFNBQWQ7Ozs7b0JBR0E7TUFBQTttREFBQSxVQUFBO01BQUE7Z0NBQUE7SUFBQTs7OztvQkFERDtNQUFBLCtFQUFBO01BQUE7TUFBa0Qsd0NBQ2pEO1VBQUEsOERBQUE7VUFBQTtjQUFBLGdDQUE0RTs7O1FBRHBEO1FBQXpCLFdBQXlCLFNBQXpCO1FBQzBCO1FBQXpCLFdBQXlCLFNBQXpCOzs7O29CQUxEO01BQUEsZ0NBQUE7b0JBQUEsbUNBR007TUFBQSxTQUNOO01BQUEsZ0NBQUE7b0JBQUEsbUNBRU07TUFBQTs7SUFONkI7SUFBbkMsV0FBbUMsU0FBbkM7SUFJSztJQUFMLFdBQUssU0FBTDs7OztvQkNKQTtNQUFBO2FBQUE7VUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/navbar/navbar.component.ngfactory.ts